import { FocusEvent, useRef, useState } from 'react';
import { CheckedState } from '@radix-ui/react-checkbox';
import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms';
import classNames from 'classnames';

import { JabraCheckbox } from '@gn-audio/jss-components/components/JabraCheckbox/JabraCheckbox';

import { longDescriptionColor } from '../../contexts/FormTheme/formThemes';
import { CheckboxViewModel } from '../../types/checkbox';
import { RichLabelProps } from '../Shared/JabraLabel';

export const getCheckboxClassNames = (hasFocus: boolean, hasAnyError: boolean): string =>
  classNames('mr-6 shrink-0 grow-0', {
    'border-gray-700 bg-white': !hasFocus && !hasAnyError,
    'border-yellow bg-white': hasFocus,
    'border-error bg-error/20': hasAnyError,
  });

const Checkbox: React.FC<ValueFieldProps<CheckboxViewModel>> = (props) => {
  const { errors, field, isValid, value, tracker } = props;
  const { id, name } = field.valueField;
  const { displayLabel, labelCssClass, required } = field.model;
  const [hasFocus, setHasFocus] = useState(false);
  const hasAnyError = !!errors?.length;
  const FieldValidationErrors = props.fieldValidationErrorsComponent as React.FC;
  const Label = props.labelComponent as React.FC<RichLabelProps>;

  const checkboxRef = useRef(null);

  const onChange = (isChecked: CheckedState) => {
    props.onChange(name, !!isChecked.valueOf(), isValid, []);
  };
  const onFocus = (event: FocusEvent<HTMLButtonElement>) => {
    tracker.onFocusField(field, event?.target?.value);
    setHasFocus(true);
  };
  const onBlur = (event: FocusEvent<HTMLButtonElement>) => {
    tracker.onBlurField(field, event?.target?.value);
    setHasFocus(false);
  };

  const handleDescriptionClick = () => {
    (checkboxRef.current as unknown as HTMLButtonElement).click();
  };
  const hasLabel = !!Label && (props.field.model.title || props.field.model.richTitle);

  return (
    <>
      {hasLabel && (
        <Label textColor={longDescriptionColor} className={`!text-base font-normal`} {...props} />
      )}
      <div className="flex">
        <JabraCheckbox
          id={id}
          name={name}
          ref={checkboxRef}
          value={value}
          checked={!!value}
          required={required}
          className={getCheckboxClassNames(hasFocus, hasAnyError)}
          onCheckedChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
        />
        {!hasLabel ? (
          <label
            className={classNames('cursor-default', longDescriptionColor, labelCssClass)}
            dangerouslySetInnerHTML={{ __html: displayLabel || '' }}
            htmlFor={id}
          />
        ) : (
          <p
            className={classNames('cursor-default', longDescriptionColor, labelCssClass)}
            dangerouslySetInnerHTML={{ __html: displayLabel || '' }}
            onClick={handleDescriptionClick}
          />
        )}
      </div>
      {!!FieldValidationErrors && <FieldValidationErrors {...props} />}
    </>
  );
};
export default Checkbox;
